import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Stethoscope, Dog, CheckCircle, Upload, MapPin } from 'lucide-react';
import './RegistrationForm.css';

const RegistrationForm = () => {
  const navigate = useNavigate();
  const [docType, setDocType] = useState('human');

  return (
    <div className="reg-page-container">
      {/* LEFT SIDE: Fixed Content (As per screenshots) */}
      <div className="reg-left-sidebar">
        {/* <button className="back-home-btn" onClick={() => navigate('/portal')}>
          <ArrowLeft size={18} /> Back
        </button> */}
        <div className="sidebar-sticky-content">
          <h1>Join Our Medical Network</h1>
          <p>
            Connect with patients and expand your practice through our trusted healthcare platform. 
            Register now to become part of our professional medical community.
          </p>
        </div>
      </div>

      {/* RIGHT SIDE: Scrollable Form Area */}
      <div className="reg-form-scroll-area">
        <div className="form-wrapper">
          <form action="https://api.web3forms.com/submit" method="POST">
            {/* Replace with your Access Key */}
            <input type="hidden" name="access_key" value="YOUR_ACCESS_KEY_HERE" />
            
            <h2 className="main-title">Doctor Registration</h2>

            {/* Doctor Type selection */}
            <div className="doc-type-grid">
              <div className={`type-box ${docType === 'human' ? 'active' : ''}`} onClick={() => setDocType('human')}>
                <Stethoscope size={32} />
                <div><h4>Human Doctor</h4><p>General & Specialist</p></div>
                {docType === 'human' && <CheckCircle className="tick" size={18} />}
              </div>
              <div className={`type-box ${docType === 'vet' ? 'active' : ''}`} onClick={() => setDocType('vet')}>
                <Dog size={32} />
                <div><h4>Vet Doctor</h4><p>Animal Care</p></div>
                {docType === 'vet' && <CheckCircle className="tick" size={18} />}
              </div>
            </div>

            {/* SECTION 1: Personal Information */}
            <div className="form-card">
              <h3>Personal Information</h3>
              <div className="row">
                <div className="col"><label>Full Name *</label><input type="text" name="name" placeholder="Dr. John Doe" required /></div>
                <div className="col"><label>Mobile Number *</label><input type="tel" name="phone" placeholder="9876543210" required /></div>
              </div>
              <div className="row"><div className="col full"><label>Email Address *</label><input type="email" name="email" placeholder="doctor@example.com" required /></div></div>
              <div className="row"><div className="col full">
                <label>Profile Picture *</label>
                <div className="upload-box">
                    <Upload size={20}/> <span>Choose File</span>
                    <input type="file" name="profile_pic" />
                </div>
              </div></div>
            </div>

            {/* SECTION 2: Professional Information (Updated with Experience Dropdown) */}
            <div className="form-card">
              <h3>Professional Information</h3>
              <div className="row">
                <div className="col">
                  <label>Category *</label>
                  <select name="category">
                    <option>Select Category</option>
                    <option>Cardiologist</option>
                    <option>Dentist</option>
                    <option>General Physician</option>
                  </select>
                </div>
                <div className="col"><label>Specialization *</label><input type="text" name="specialization" placeholder="Cardiology" /></div>
              </div>
              <div className="row">
                <div className="col"><label>Qualification *</label><input type="text" name="qualification" placeholder="MBBS, MD" /></div>
                <div className="col">
                   <label>Experience *</label>
                   <div className="experience-group">
                      <input type="number" name="experience_value" placeholder="5" className="exp-input" />
                      <select name="experience_unit" className="exp-unit">
                        <option value="Years">Years</option>
                        <option value="Months">Months</option>
                      </select>
                   </div>
                </div>
              </div>
              <div className="row">
                <div className="col"><label>License Number *</label><input type="text" name="license" placeholder="MED123456" /></div>
                <div className="col">
                   <label>License Photo *</label>
                   <div className="upload-box sm-upload"><input type="file" name="license_img" /></div>
                </div>
              </div>
              <div className="row"><div className="col full"><label>UPI ID *</label><input type="text" name="upi" placeholder="doctor@upi" /></div></div>
            </div>

            {/* SECTION 3: Practice Details */}
            <div className="form-card">
              <h3>Practice Details</h3>
              <div className="row">
                <div className="col"><label>Consultation Fee *</label><input type="number" name="fee" placeholder="500" /></div>
                <div className="col"><label>Location *</label><div className="loc-input"><input type="text" name="location" placeholder="Search place..." /><MapPin size={16}/></div></div>
              </div>
              <div className="row"><div className="col full"><label>Hospital Affiliation *</label><input type="text" name="hospital" placeholder="ABC Hospital" /></div></div>
              <div className="row"><div className="col full">
                <label>Availability *</label>
                <textarea name="availability" placeholder="Monday-Friday: 9 AM - 5 PM" rows="3"></textarea>
              </div></div>
              <div className="row"><div className="col full"><label>Service Areas (PIN Codes) *</label><input type="text" name="service_areas" placeholder="e.g. 400001, 380015" /></div></div>
            </div>

            <button type="submit" className="submit-portal-btn">Complete Registration →</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;